// Tipos de atividade; manter os identificadores compatíveis com a constraint activities_tipo_check (src/db/migrations/crm).
export const ACTIVITY_TYPE_LABELS = {
  tarefa: 'Tarefa',
  ligacao: 'Ligação',
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  reuniao: 'Reunião',
  demonstracao: 'Demonstração',
  visita: 'Visita',
  proposta: 'Proposta',
  follow_up: 'Follow-up',
  linkedin_conexao: 'Conexão no LinkedIn',
  linkedin_mensagem: 'Mensagem no LinkedIn',
  briefing: 'Briefing',
  enviar_contrato: 'Enviar contrato',
  coletar_documentos: 'Coletar documentos',
  onboarding: 'Onboarding',
  pagamento: 'Pagamento',
  evento: 'Evento',
  mensagem: 'Nota', // Legado: novas notas são criadas no Histórico.
}

export const ACTIVITY_TASK_TYPES = Object.keys(ACTIVITY_TYPE_LABELS).filter(type => type !== 'mensagem')

// Ícones do catálogo compartilhado por tarefas de projetos.
export const ACTIVITY_TYPE_ICONS = {
  tarefa: 'page', ligacao: 'phone', whatsapp: 'whatsapp', email: 'mail',
  reuniao: 'users', demonstracao: 'ads', visita: 'geo', proposta: 'page',
  follow_up: 'refresh', linkedin_conexao: 'users', linkedin_mensagem: 'mail',
  briefing: 'timeline', enviar_contrato: 'send', coletar_documentos: 'folder',
  onboarding: 'briefcase', pagamento: 'dollar_circle', evento: 'calendar',
}
